module.exports = __webpack_public_path__ + "img/polygone2.2a324eac.png";